<template>
    <form-row title="Has Inspection Been Completed?">
        <div class="flex flex-col sm:flex-row flex-1 sm:items-center">
            <input-radio-boolean
                name="inspection_has_been_completed"
                v-model="inspection_has_been_completed"
                true="Yes"
                false="No"
                :read_only="read_only"
            />

            <input-date
                v-if="inspection_has_been_completed"
                class="mt-4 sm:ml-12 sm:-mt-2 sm:-mb-2 flex flex-1 items-center sm:justify-end"
                label="Date Completed:"
                :value="inspection.inspection_completed_at"
                name="inspection_completed_at"
                :read_only="read_only"
            />
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        inspection: {},
        read_only: { default: false },
    },

    data() {
        return {
            inspection_has_been_completed: this.inspection.inspection_has_been_completed,
        }
    },
}
</script>
